import { ActionContext } from "vuex";
import { mockGetters, IActionsMock, IRootState, IState } from "@/store";
import { mockRootState, mockState } from "../store.mock";

export const mockActionsContext = (): ActionContext<IState, IRootState> => ({
  commit: jest.fn(),
  dispatch: jest.fn(),
  state: mockState(),
  getters: mockGetters(),
  rootState: mockRootState(),
  rootGetters: {},
});

export const mockActions = (): IActionsMock => ({
  initialize: jest.fn(),
  setCurrentLocation: jest.fn(),
  setCurrentLocale: jest.fn(),
  fetchLoggedUser: jest.fn(),
  fetchDisclaimer: jest.fn(),
  fetchUsersGuide: jest.fn(),
  fetchCountryConfig: jest.fn(),
  fetchI18n: jest.fn(),
  fetchUsersPage: jest.fn(),
  fetchReportsPage: jest.fn(),
  fetchDeleteReport: jest.fn(),
  fetchDownloadReport: jest.fn(),
  storeUsersReport: jest.fn(),
  fetchUserDetail: jest.fn(),
  updateUser: jest.fn(),
  addUserServicepointApproval: jest.fn(),
  removeUserServicepoint: jest.fn(),
  removeUserServicepointApprovals: jest.fn(),
  toggleAdmin: jest.fn(),
  toggleSupervisor: jest.fn(),
  toggleAprobador: jest.fn(),
  fetchClientsPage: jest.fn(),
  fetchClientDetail: jest.fn(),
  saveUpdateClient: jest.fn(),
  updateStatusClient: jest.fn(),
  fetchSubclientsPage: jest.fn(),
  fetchSubclientDetail: jest.fn(),
  saveUpdateSubclient: jest.fn(),
  updateStatusSubclient: jest.fn(),
  fetchServicepointsPage: jest.fn(),
  fetchServicepointDetail: jest.fn(),
  fetchServicepointLimits: jest.fn(),
  saveUpdateServicepoint: jest.fn(),
  updateStatusServicepoint: jest.fn(),
  fetchCountriesPage: jest.fn(),
  fetchDelegations: jest.fn(),
  fetchDelegationsByCountry: jest.fn(),
  fetchAssignableAdapters: jest.fn(),
  fetchCurrenciesPage: jest.fn(),
  fetchChannelsPage: jest.fn(),
  createChannel: jest.fn(),
  validateSolClient: jest.fn(),
  validateSolSubclient: jest.fn(),
  validateSolServicepoint: jest.fn(),
  fetchEmployee: jest.fn(),
  fetchVehicle: jest.fn(),
  fetchImage: jest.fn(),
  completeLogin: jest.fn(),
  fetchSignin: jest.fn(),
  logout: jest.fn(),
  fetchRequestHistorial: jest.fn(),
  fetchSolCustomerCurrency: jest.fn(),
  savePickUpService: jest.fn(),
  fetchSolCustomerFaults: jest.fn(),
  fetchSolCustomerPacks: jest.fn(),
  fetchSolCustomerDenominations: jest.fn(),
  saveAssistanceService: jest.fn(),
  saveDeliveryService: jest.fn(),
  fetchSolCustomerSupply: jest.fn(),
  saveSupplyMaterialService: jest.fn(),
  saveServiceRating: jest.fn(),
  fetchServiceRating: jest.fn(),
  fetchPickUpService: jest.fn(),
  fetchAssistanceService: jest.fn(),
  fetchDeliveryService: jest.fn(),
  fetchSupplyMaterialService: jest.fn(),
  fetchCancellationReasonsService: jest.fn(),
  cancelAssistanceService: jest.fn(),
  cancelDeliveryExchangeService: jest.fn(),
  cancelDeliveryService: jest.fn(),
  cancelPickupService: jest.fn(),
  cancelSupplyMaterialService: jest.fn(),
  generateOrdersReport: jest.fn(),
  fetchTypeClientsReport: jest.fn(),
  generateEmployeeSearchReport: jest.fn(),
  generateSubclientsReport: jest.fn(),
  generateServicePointReport: jest.fn(),
  generateClientsReport: jest.fn(),
});
